import React from 'react';
import Act from '../Act/Act';

export default function ActWiseView(props) {
    const ACTS = ['beg', 'mid', 'end'];

    return (
        <div>
            {ACTS.map((act, idx) => {
                    return (
                        <div className="my-3">
                            <Act actName={act} actNum={idx + 1} key={idx + 1} updateMainData={props.updateMainData} printState={props.printState} />
                        </div>
                    )
                })}
        </div>
    )
}
